// Copyright: IQGeo Limited 2010-2019

const mapping = {};

const geometryFactory = geojsonGeom => {
    if (!geojsonGeom) return geojsonGeom;

    const type = geojsonGeom.type;
    const factory = mapping[type];
    if (!factory) throw new Error(`geometry factory: Missing factory for ${type}`);

    const geom = factory();
    Object.assign(geom, geojsonGeom); //ENH: exclude type
    return geom;
};

geometryFactory.mapping = mapping;

export default geometryFactory;
